import React from 'react';
import { connect } from 'react-redux';

import { Navigate } from 'react-router-dom';

export default (Component) => {
  class Container extends React.Component {
    render() {
      const { auth } = this.props;

      if (auth?.authenticated) {
        const role = auth.user?.role?.toLowerCase();
        if (role === 'partner_viewer') {
          return <Navigate to="/partner/orders" />;
        }
        return <Navigate to="/" />;
      }

      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      auth: state.auth,
    };
  }
  return connect(mapStateToProps, {})(Container);
};
